export const theme = {
  colors: {
    text: '#1e1e1e',
    prymary: '#ffe600',
    muted: '#ffe60097',
    white: '#fff',
    light: '#fbfbfb',
  },
  shadow: '0px 2px 6px 2px rgba(92, 112, 133, 0.1)',
  radii: ['5px'],
  fonts: {
    body: '"Montserrat", sans-serif',
  },
  fontSizes: ['12px', '14px', '15px', '20px', '25px', '30px', '40px', '60px'],
  fontWeights: {
    medium: 500,
    bold: 700,
    extraBold: 800,
  },
  lineHeights: {
    lh12: '1.2',
    lh13: '1.3',
    lh15: '1.5',
    lh17: '1.7',
    lh23: '2.3',
  },
};
